import type { Resource } from '../../';
export const general_errors_renderAlerts_dateTimeTooltip: Resource = {"default":"The date and time the error occurred."};
